export default [
  {
    header: 'menu.content-management',
  },
  {
    title: 'admin.fb-replies',
    route: 'admin:fb-replies',
    icon: 'MessengerCircleIcon',
  },
  {
    title: 'admin.instagram-replies',
    route: 'admin:instagram-replies',
    icon: 'InstagramIcon',
  },
  {
    title: 'menu.admin-help',
    route: 'admin:help',
    icon: 'HelpCircleIcon',
  },
  {
    title: 'menu.notifications',
    route: 'admin:notifications',
    icon: 'BellIcon',
  },
]
